import type { AgentToolCall } from '@multiplayer-app/ai-agent-types'
import { AgentToolCallStatus } from '@multiplayer-app/ai-agent-types'

export const getToolStatusMessage = (call: AgentToolCall, toolLabel: string): string => {
  switch (call.status) {
    case AgentToolCallStatus.Running:
      return `Running ${toolLabel}...`
    case AgentToolCallStatus.Succeeded:
      return `Completed ${toolLabel}`
    case AgentToolCallStatus.Failed:
      return `Failed to run ${toolLabel}`
    case AgentToolCallStatus.Pending:
      return `Preparing ${toolLabel}...`
    default:
      return `Running ${toolLabel}...`
  }
}

export const formatDebugJson = (value: unknown): string => {
  if (value === undefined) return 'undefined'
  try {
    const out = JSON.stringify(value, null, 2)
    return out ?? 'undefined'
  } catch {
    try {
      return String(value)
    } catch {
      return '[unserializable]'
    }
  }
}

